module.exports = __webpack_public_path__ + "img/icon-point.a1ba60df.png";